/*
 Title: classNames.ts
 Purpose: Shared utility to compose optional className tokens
 Last-Modified: 2026-02-21
 Notes: Keep tiny and dependency-free.
*/

export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter((value): value is string => typeof value === "string" && value.trim().length > 0).join(" ");
}

